import { IFootballConfig, ITeam, ITeamH2H } from '../../../../packages/types';
import { removeUndefinedPropertiesFromObject, LinkCreationService, getTeamName } from '@sportal365/smp-widget-utils';
import { assetsPlaceholder } from '../../../../packages/constants/assetsPlaceholder';
import { TARGET_SELF, TARGET_BLANK } from '../../../../packages/constants/windowTarget';
import { TEAM_ENTITY } from '../../../../packages/constants/entityTypes';

interface INormalizeFootballTeamDataArgs {
  team?: ITeam | ITeamH2H | null;
  dataEntityLinks?: IFootballConfig['dataEntityLinks'];
  dataTeamNameType?: IFootballConfig['dataTeamNameType'];
}

export const normalizeFootballTeam = ({ team, dataEntityLinks, dataTeamNameType }: INormalizeFootballTeamDataArgs) => {
  if (!team) return;

  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);

  return removeUndefinedPropertiesFromObject({
    id: team.id,
    name: getTeamName(team, dataTeamNameType),
    logo: team.assets?.logo?.url || team?.logo || assetsPlaceholder.team,
    link: linkService?.createEntityUrl(String(team.id), TEAM_ENTITY, '', team.slug) ?? '#',
    urlTarget: dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF,
    type: team.type,
  });
};
